import React from 'react';

const SlideIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={(size * 21) / 24}
    viewBox='0 0 24 21'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M21.622 2.33297L20.0646 9.33352H3.41515L4.97252 2.33297H21.622L22.1405 0H3.11139L8.8951e-09 13.9995H2.37634L1.85777 16.3341H8.9935L8.47493 18.667H3.71722L3.19866 21H15.0921L15.6107 18.667H10.8529L11.3715 16.3341H20.8869L24 2.33297H21.622ZM19.0275 13.9995H2.37802L2.89658 11.6665H19.546L19.0275 13.9995ZM11.8918 3.50027H14.2698L13.7512 5.83324H11.3732L11.8918 3.50027Z' />
  </svg>
);

export default SlideIcon;
